module.exports = __webpack_public_path__ + "img/winner.ea43f92e.png";